/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  forwardRef, useEffect,
} from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { useForm } from 'react-hook-form';
import {
  Button,
  Dialog, DialogContent, DialogTitle, Grid, IconButton, Zoom,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import RequiredFiled from '../../../../Common/RequiredField';
import ComponentTextInput from '../../../../Common/ComponentTextinput/ComponentTextInput';
import { AddLevelFields, AddZipCodeModalTypes } from '../../utils/types';
import { addLevelSchema } from '../../utils/validation';
import { createLevelStart } from '../../../../redux/masters/masterSlice';
import { RootState } from '../../../../redux/rootState';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Zoom ref={ref} {...props} />);

function AddLevelModal({
  show, setOpenFrom, selectedId,
}: AddZipCodeModalTypes): JSX.Element {
  const {
    control, formState: { errors }, reset, handleSubmit, setValue,
  } = useForm<AddLevelFields>({
    defaultValues: {
      description: '',
    },
    resolver: yupResolver(addLevelSchema as ObjectSchema<AddLevelFields>),
  });
  const dispatch = useDispatch();
  const { allLevelsList } = useSelector((state: RootState) => state.masterDataReducer);

  useEffect(() => {
    if (show === 'Edit' && selectedId) {
      const levelData = allLevelsList?.Data?.find((level) => String(level.Id) === selectedId);
      setValue('description', levelData?.Description || '');
    }
  }, [show, selectedId, allLevelsList]);

  const handleClose = () => {
    setOpenFrom();
    reset();
  };

  const onSubmit = (data: AddLevelFields) => {
    let payload = {};
    if (show === 'Edit') {
      payload = {
        Id: Number(selectedId),
        Description: data.description,
      };
    } else {
      payload = {
        Description: data.description,
      };
    }

    dispatch(createLevelStart(payload));
    handleClose();
  };

  return (
    <div>
      <Dialog
        maxWidth="sm"
        PaperProps={{
          className: 'paperStyle',
        }}
        open={show?.length > 0}
        transitionDuration={500}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpenFrom}
      >
        <DialogTitle className="modalHeaderTitle">
          {show}
          {' '}
          Level
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: '16px 24px' }}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Grid container spacing={2}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Description
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name="description"
                    size="small"
                    id="description"
                    errors={errors}
                    inputProps={{ maxLength: 40 }}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="save_and_next_div">
                  <div>
                    <Button className="button_cancel" onClick={handleClose}>Cancel</Button>
                  </div>
                  <div className="button_margin_left">
                    <Button type="submit" className="button_save_and_next">Save</Button>
                  </div>
                </div>
              </Grid>

            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AddLevelModal;
